
import { Vue, Component, Prop } from "vue-property-decorator";

import DocumentProvider from "@/components/documents/DocumentProvider.vue";
import { Document, User } from "@/generated/graphql";
import PDFIcon from "@/components/icons/pdf-icon.vue";
import DocumentIcon from "@/components/icons/document-icon.vue";
import ConfirmRemovingDocumentModal from "@/components/documents/ConfirmRemovingDocumentModalNew.vue";
import Processing from "@/components/common/Processing.vue";
import MoreActions from "@/components/common/MoreActionsClick.vue";
import Roles from "@/entities/Roles";
import DOCIcon from "@/components/icons/DOCIcon.vue";
import SearchableListConfig from "@/entities/SearchableListConfig";
import searchableListConfig from "@/data/searchableListConfig";

@Component({
  components: {
    DocumentProvider,
    Processing,
    DocumentIcon,
    DOCIcon,
    PDFIcon,
    MoreActions,
    ConfirmRemovingDocumentModal,
  },
})
export default class DocumentTable extends Vue {
  @Prop({ type: Object, required: true }) readonly documents!: Document[];
  @Prop({ type: Boolean, default: false }) readonly frozen!: boolean;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Boolean, default: false }) readonly extraInfoHidden!: boolean;
  @Prop({ type: String, default: undefined }) readonly customRequestId?: string;

  searchableListConfig: SearchableListConfig = { ...searchableListConfig };
  showModal = false;
  removeFunction: (() => void) | null = null;
  docuemntToRemove: null;

  removeDocument() {
    if (this.frozen) {
      return;
    }
    this.removeFunction();
  }

get isResource() {
    return this.currentUser.role === Roles.CONTRACTOR;
  }

  deleteModal(document,remove){
this.showModal = true;
this.removeFunction = remove;
this.docuemntToRemove = document;
}

  isFrozen(document: Document): boolean {
    if (this.frozen) {
      return true;
    }

    if (this.currentUser.role === "ADMIN") {
      return false;
    }

    if (this.customRequestId) {
      return false;
    }

    return this.currentUser.id !== document.uploaded_by;
  }
  formatDate(dateToBeFormatted) {
    const date = new Date(dateToBeFormatted);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  }
  getDocumentSize(size) {
    size = (Number(size) / 1024).toFixed(1).replace(".0", "");

    return `${size} kB`;
  }
  // async updateDocumentList(): Promise<void>{
  //     this.$emit("listChanged");
  //     await this.$apollo.queries.documents.refetch();
  //     this.$emit("documentNumberChanged", this.searchableListConfig.total)
  //   }
}
